import React from 'react'
import { Box } from '@chakra-ui/react'

export default (props) => {
  return <Box {...props} />
}
